import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { barrierTypeSchema } from './shared/barrier-type.schema';
import { baseStructuredSchema } from './shared/base-structured.schema';
import { contractTypeSchema } from './shared/contract-type.schema';
export const vanillaStructuredSchema = baseStructuredSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.VanillaStructured),
    participation_rate: z.number(),
    contract_type: contractTypeSchema,
    barrier_type: barrierTypeSchema,
    knockdown_input_level: z.number(),
});
